import TyTextarea from './TyTextarea.vue'
export default TyTextarea



// WEBPACK FOOTER //
// ./src/components/ty-textarea/index.js